<template>
  <div>
    <b-container>
      <b-row>
        <b-col class="text-center">
          <img class="logo" src="../assets/chronext-logo.svg" />
          <h1>Supplier Portal</h1>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col cols="8" class="text-center">
          <hr />
          <router-link :to="{ name: 'login' }" class="btn btn-lg btn-success">Login</router-link>
          <hr />
        </b-col>
      </b-row>
    </b-container>
    <div class="light-grey">
      <b-container class="info-box">
        <b-row class="justify-content-center">
          <b-col cols="8" class="text-center">
            <h2>Merchant Partnerships with CHRONEXT</h2>
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <b-col cols="8" class="text-center">
            <p>
              You want to know more about a strategic partnership with CHRONEXT? Write an email to
              <a href="mailto:partner@chronext.com">partner@chronext.com</a>
            </p>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Homepage',
  props: {},
};
</script>

<style scoped>
.info-box {
  padding: 20px 15px;
}
.info-box h2 {
  font-family: 'Playfair Display', serif;
}
.info-box p {
  font-weight: 300;
}
.btn {
  margin-left: 10px;
  margin-right: 10px;
}
h1 {
  font-size: 3rem;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 2px;
}
.logo {
  height: 50px;
}
.container {
  margin-top: 50px;
}
.logo {
  margin-bottom: 20px;
}
.light-grey {
  background-color: #f5f5f5;
}
</style>
